import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 18v-15l7 4l-7 4","key":"svg-0"}],["path",{"d":"M9 17.67c-.62 .36 -1 .82 -1 1.33c0 1.1 1.8 2 4 2s4 -.9 4 -2c0 -.5 -.38 -.97 -1 -1.33","key":"svg-1"}]]

/**
 * IconGolf
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZ29sZiIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgMTh2LTE1bDcgNGwtNyA0IiAvPgogIDxwYXRoIGQ9Ik05IDE3LjY3Yy0uNjIgLjM2IC0xIC44MiAtMSAxLjMzYzAgMS4xIDEuOCAyIDQgMnM0IC0uOSA0IC0yYzAgLS41IC0uMzggLS45NyAtMSAtMS4zMyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/golf
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconGolf = createReactComponent('outline', 'golf', 'Golf', __iconNode);

export default IconGolf;